<div class="container-fluid">
  <section id="carrusel" class="container-fluid carrusel mb-3">
    <owl-carousel-o [options]="optionsDefault">
      <ng-container *ngFor="let car of carindex; let i = index">
        <ng-template carouselSlide>
          <img [src]="car.url_imagen_index" [alt]="'imagen '+i" [title]="'imagen '+i" style="height: calc(100vh - 9.3125rem);">
        </ng-template>
      </ng-container>
    </owl-carousel-o>

  </section>
  <ng-container *ngFor="let cat of categorias">
    <section class="top-categoria">
      <div class="row" *ngIf="cat.show">
        <div class="col-lg-2"></div>
        <div class="col-lg-9">
          <h3 class="titulos"><a [routerLink]="['/productos']" [queryParams]="{T:cat.id}"
                                 [matTooltip]="'Ver Mas'">{{cat.descri|titlecase}}</a></h3>
          <hr class="bg-naranja full-width" style="height: 2px;"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-10">
          <app-producto-inicio [tipoProd]="cat.id" (showEvent)="setShow($event,cat)"></app-producto-inicio>
        </div>
      </div>
    </section>
  </ng-container>
</div>
